export const HELP_CONSTANTS = {
  interstitialDuration: 2000,
  initialSteps: {
    steps: [
      { slug: 'subject', type: 'question', visible: true, answer: '' },
      { slug: 'customer-intent', type: 'question', visible: false, answer: '' },
      { slug: 'help-login', type: 'auth', visible: false },
      { slug: 'reference-list', type: 'list', visible: false },
      { slug: 'topic', type: 'question', visible: false, answer: '' },
      { slug: 'contact', type: 'contact', visible: false }
    ],
    activeStepIndex: 0 // current active step's index
  },
  step_questions: [
    {
      label: 'What would you like support with?',
      key: 'subject',
      type: 'choice',
      settings: {}
    },
    {
      label: 'What can we help you with?',
      key: 'customer-intent',
      type: 'choice',
      settings: {}
    },
    {
      key: 'reference-list',
      type: 'choice',
      settings: {
        choices: []
      }
    },
    {
      label: 'Choose a topic',
      key: 'topic',
      type: 'choice',
      settings: {}
    }
  ],
  step_options: [
    {
      key: 'subject',
      choices: [
        {
          key: 'quote',
          label: 'Buy a new policy',
          value: 'quote',
          icon: 'management-quote',
          action: 'bookAppointment'
        },
        {
          key: 'flight',
          label: 'Smart Flight Delay',
          value: 'flight',
          icon: 'management-updateflightdetails',
          action: 'flow',
          requiresTravelPolicyWithSfd: true
        },
        {
          key: 'payment',
          label: 'Manage my payments',
          value: 'payment',
          icon: 'management-payment',
          action: 'flow',
          requiresPolicy: true
        },
        {
          key: 'policy',
          label: 'Manage a policy',
          value: 'policy',
          icon: 'management-managepolicies',
          action: 'flow',
          requiresPolicy: true
        },
        {
          key: 'claim',
          label: 'Manage or make a claim',
          value: 'claim',
          icon: 'management-claim',
          action: 'flow',
          requiresPolicy: true
        },
        {
          key: 'coverage',
          label: 'Check my coverage',
          value: 'coverage',
          icon: 'management-aboutyourcover',
          action: 'bookAppointment'
        },
        {
          key: 'odo',
          label: 'Enter odometer reading',
          value: 'odo',
          icon: 'management-addodometer',
          action: 'flowRef-selfServe'
        },
        {
          key: 'other',
          label: 'Share feedback or personal situation',
          value: 'other',
          icon: 'people-tenants',
          action: 'flow'
        }
      ]
    },
    {
      key: 'customer-intent_payment',
      choices: [
        {
          key: 'retry-payment',
          label: 'Retry my payment',
          value: 'retry-payment',
          icon: 'management-retrypayment',
          action: 'flowRef-selfServe'
        },
        {
          key: 'update-payment',
          label: 'Update my payment details',
          value: 'update-payment',
          icon: 'management-updatepayment',
          action: 'flowRef-selfServe'
        }
      ]
    },
    {
      key: 'customer-intent_policy',
      choices: [
        {
          key: 'update-policy',
          label: 'Change my policy',
          value: 'update-policy',
          icon: 'management-updatepolicy',
          action: 'flowRef-endorse',
          requiresActiveUpcomingPolicy: true
        },
        {
          key: 'update-renewal',
          label: 'Manage my policy renewal',
          value: 'update-renewal',
          icon: 'management-renewal',
          action: 'flow',
          requiresActivePolicy: true
        },
        {
          key: 'cancel-policy',
          label: 'Cancel my policy',
          value: 'cancel-policy',
          icon: 'management-cancelpolicy',
          action: 'flowRef-selfServe',
          requiresActiveUpcomingPolicy: true
        },
        {
          key: 'policy-documents',
          label: 'Get my policy documents',
          value: 'policy-documents',
          icon: 'management-documents',
          action: 'flowRef-selfServe'
        }
      ]
    },
    {
      key: 'customer-intent_claim',
      choices: [
        {
          key: 'start-claim',
          label: 'Make a claim',
          value: 'start-claim',
          icon: 'management-startclaim',
          action: 'flowRef-selfServe',
          requiresPolicy: true
        },
        {
          key: 'existing-claim',
          label: 'Get help with my existing claim',
          value: 'existing-claim',
          icon: 'management-helpexistingclaim',
          action: 'flowRef-bookAppointment',
          requiresClaim: true
        }
      ]
    },
    {
      key: 'customer-intent_flight',
      choices: [
        {
          key: 'add-flight',
          label: 'Add my flight details',
          value: 'add-flight',
          icon: 'management-updateflightdetails',
          action: 'smartFlightDelay',
          requiresTravelPolicyWithSfd: true
        },
        {
          key: 'existing-flight',
          label: 'Get help with Smart Flight Delay',
          value: 'existing-flight',
          icon: 'people-tenants',
          action: 'smartFlightDelay',
          requiresTravelPolicyWithSfd: true
        }
      ]
    },
    {
      key: 'customer-intent_other',
      choices: [
        {
          key: 'complaint',
          label: 'Make a complaint',
          value: 'complaint',
          icon: 'management-makeacomplaint',
          action: 'bookAppointment'
        },
        {
          key: 'feedback',
          label: 'Share feedback',
          value: 'feedback',
          icon: 'people-tenants',
          action: 'bookAppointment'
        },
        {
          key: 'financial-difficulties',
          label: 'I\'m experiencing financial hardship',
          value: 'financial-difficulties',
          icon: 'management-financialhardship',
          action: 'bookAppointment'
        },
        {
          key: 'login-help',
          label: 'Get help with logging in',
          value: 'login-help',
          icon: 'management-helploggingin',
          action: 'bookAppointment'
        },
        {
          key: 'other',
          label: 'I need to speak to someone',
          value: 'other',
          icon: 'people-employees',
          action: 'bookAppointment'
        }
      ]
    },
    {
      key: 'topic_update-renewal',
      choices: [
        {
          key: 'endorse-renewal',
          label: 'Update my renewal details',
          value: 'endorse-renewal',
          icon: 'management-updaterenewaldetails',
          action: 'bookAppointment'
        },
        {
          key: 'toggle-autorenew',
          label: 'Change my auto-renewal',
          value: 'toggle-autorenew',
          icon: 'management-changeautorenewal',
          action: 'selfServe'
        }
      ]
    },
    {
      key: 'topic_policy-documents',
      choices: [
        {
          key: 'coc',
          label: 'Get my Certificate of Currency',
          value: 'coc',
          icon: 'management-bankaccount',
          action: 'selfServe'
        },
        {
          key: 'coi',
          label: 'Get my Certificate of Insurance',
          value: 'coi',
          icon: 'management-claim',
          action: 'selfServe'
        },
        {
          key: 'pds',
          label: 'Get my Product Disclosure Statement',
          value: 'pds',
          icon: 'management-aboutyourcover',
          action: 'selfServe'
        }
      ]
    }
  ],
  charlesTaylorNumber: '+61 8 6150 4250',
  sfdNumber: '+61 2 8000 1663',
  policyBadgeStatus: {
    active: 'success',
    upcoming:'default',
    cancelled: 'error',
    inactive: 'inactive'
  }
};

export const RAPTOR_SUPPORT_FLOW_TOPICS: { [key: string]: { subject: string; 'customer-intent'?: string } } = {
  quoteFlow: {
    subject: 'quote',
    'customer-intent': ''
  },
  endorsementFlow: {
    subject: 'policy',
    'customer-intent': 'update-policy'
  },
  cancellationFlow: {
    subject: 'policy',
    'customer-intent': 'cancel-policy'
  },
  prerenewalFlow: {
    subject: 'policy',
    'customer-intent': 'policy-renewal'
  },
  updatePaymentFlow: {
    subject: 'payment',
    'customer-intent': 'update-payment'
  }
};

export const APPOINTMENT_BOOKING_TOPICS: { [key: string]: { topic: string, option: string, entity?: string, entity_ref?: string } } = {
  quoteFlow: {
    topic: 'new_business',
    option: 'purchase_policy',
    entity: 'raptor-quote'
  },
  'update-policy': {
    topic: 'update_policy',
    option: 'endorsement',
    entity: 'raptor-policy'
  },
  'cancel-policy': {
    topic: 'cancel_policy',
    option: 'general_enquiry',
    entity: 'raptor-policy'
  },
  'policy-renewal': {
    topic: 'renewals',
    option: 'renewal_endorsement',
    entity: 'raptor-policy'
  },
  'update-payment': {
    topic: 'payment',
    option: 'general_enquiry'
  },
  'update-renewal': {
    topic: 'renewals',
    option: 'renewal_endorsement',
  },
  'existing-claim': {
    topic: 'claim',
    option: 'existing_claim',
    entity: 'claim'
  },
  complaint: {
    topic: 'complaint',
    option: 'other'
  },
  'financial-difficulties': {
    topic: 'payment',
    option: '',
    entity: 'policy'
  },
  contactUs: {
    topic: 'contactus',
    option: 'general_enquiry',
  },
  'coverage': {
    topic: 'contactus',
    option: 'other'
  },
};

export const ASSISTED_SUPPORT_REQUEST_TOPICS = [
  'existing-claim'
];
